// extracted by mini-css-extract-plugin
export default {"Companies":"Companies_Companies__xPhyW","Record":"Companies_Record__G6BGl"};